import { QueryModelCore } from "@/core/model.core";

export default class Prom {
  /**
   * 获取我的优惠券列表
   * @param {Number} couponStatus 优惠券状态 1-未使用 2-已使用 4-已过期
   */
  async myCouponList(couponStatus) {
    const result = await new QueryModelCore('/api-prom/couponApplet/getMyCoupons').get({ couponStatus });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取订单可用优惠券
   * @param {string} spuNo
   * @param {number} tradeAmount 订单总金额
   */
  async orderCouponList({ spuNo, tradeAmount }) {
    const result = await new QueryModelCore('/api-prom/couponApplet/getAvailableCoupons').get({ spuNo, tradeAmount });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取优惠券适用商品列表(分页)
   * @param {Object} params {
   *    @param {number} current
   *    @param {number} size
   *    @param {string} couponId 优惠券id
   * }
   */
  async couponProdPagingList(params) {
    const result = await new QueryModelCore('/api-prom/couponApplet/goUse').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取商品适用优惠券
   * @param {string} spuNo 内部自动生成的产品编码
   */
  async couponListBySpuNo(spuNo) {
    const result = await new QueryModelCore('/api-prom/coupon/app/goodsCoupon').get({ spuNo });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 领取商品适用优惠券
   * @param {Number} pickType 领券类型: 0-单张优惠券(需传券id) 1-一键领券
   * @param {string} spuNo 内部自动生成的产品编码(必填)
   * @param {Number} id 券id
   */
  async pickCoupon(params) {
    const result = await new QueryModelCore('/api-prom/couponApplet/pickGoodsCoupon').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 查看活动题目
  async signupDetail(params) {
    const result = await new QueryModelCore('/api-prom/app/YlApply/view').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户取消报名
  async signupCancel(params) {
    const result = await new QueryModelCore('/api-prom/app/YlApply/cancelApply').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户报名结果页
  async signupResult(params) {
    const result = await new QueryModelCore('/api-prom/app/YlApply/resultPage').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 提交报名
  async signupSubmit(params) {
    const result = await new QueryModelCore('/api-prom/app/YlApply/submit').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 详情
  async signupPreviewDetail(params) {
    const result = await new QueryModelCore('/api-prom/applyYl/preview').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 查询活动状态
  async signupStatus(params) {
    const result = await new QueryModelCore('/api-prom/app/YlApply/checkStatus').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 查看
  async getQrpage(params) {
    const result = await new QueryModelCore('/api-prom/app/qrPage/view').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 访问页面
  async accessQrpage(params) {
    const result = await new QueryModelCore('/api-prom/app/qrPage/access').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 收藏&取消
  async collectQrpage(params) {
    const result = await new QueryModelCore('/api-prom/app/qrPage/collect').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 校验密码
  async checkQrpage(params) {
    const result = await new QueryModelCore('/api-prom/app/qrPage/verifyPassword').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 基础配置
  async getQrMiniConfig(params) {
    const result = await new QueryModelCore('/api-prom/qrPage/outAppList').get(params);
    const { dataMap } = result;
    return dataMap;
  }
}
